var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.4996 7.50019V10.8335M10.4996 14.1669H10.508M9.34573 3.24329L2.49166 15.0821C2.11149 15.7388 1.9214 16.0671 1.9495 16.3366C1.974 16.5716 2.09714 16.7852 2.28828 16.9242C2.50741 17.0835 2.88679 17.0835 3.64556 17.0835H17.3537C18.1125 17.0835 18.4919 17.0835 18.711 16.9242C18.9021 16.7852 19.0253 16.5716 19.0498 16.3366C19.0779 16.0671 18.8878 15.7388 18.5076 15.0821L11.6535 3.24329C11.2747 2.58899 11.0853 2.26184 10.8382 2.15196C10.6227 2.05612 10.3766 2.05612 10.1611 2.15196C9.91394 2.26184 9.72454 2.58899 9.34573 3.24329Z",
    stroke: "#93370D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.c9a471be3206d54c33fc1a92e80409db.svg";
export { ForwardRef as ReactComponent };